<script setup>
import { computed } from 'vue';
import { mostrarDatoEstructura, parsearNombreGrupoConProfesor } from './constantes';

const props = defineProps({
  columna: { type: Object, required: true },
  isUltima: { type: Boolean, default: false },
});

const emit = defineEmits(['seleccionar']);

const itemsConNombre = computed(() => props.columna.items.map((item) => {
  const texto = mostrarDatoEstructura(item);
  return { item, texto, nombreParsed: parsearNombreGrupoConProfesor(texto) };
}));
</script>

<template>
  <div
    class="selector-columna"
    :class="[`selector-columna--${columna.type}`, { 'selector-columna--ultima': isUltima }]"
  >
    <div class="columna-titulo">
      {{ columna.title }}
    </div>
    <div class="columna-items">
      <button
        v-for="{ item, texto, nombreParsed } in itemsConNombre"
        :key="item.id"
        type="button"
        class="selector-item"
        :class="{ selected: item.id === columna.selectedId }"
        @click="emit('seleccionar', { item, tipo: columna.type })"
      >
        <template v-if="nombreParsed">
          <span class="selector-item-texto">
            <strong>{{ nombreParsed.grupo }}</strong>
            <small class="selector-item-profesor">{{ nombreParsed.profesor }}</small>
          </span>
        </template>
        <span v-else>{{ texto }}</span>
        <i v-if="item.conHijos" class="fa fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/../assets/stylesheets/cifra/vars/main.scss';

.selector-columna {
  min-width: 180px;
  flex: 0 0 180px;

  &.selector-columna--anno_lectivo {
    min-width: 150px;
    flex: 0 0 150px;
  }

  &.selector-columna--ultima {
    flex: 1;
  }
  background: #ededed;
  background: linear-gradient(180deg, rgba(237, 237, 237, 1) 0%, rgba(255, 255, 255, 1) 100%);
  border-radius: 0.5rem;
  padding: 0.75rem;
  min-height: 200px;
  display: flex;
  flex-direction: column;
}

.columna-titulo {
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.columna-items {
  overflow-y: auto;
  flex: 1;
}

.selector-item {
  width: 100%;
  text-align: left;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  margin-bottom: 0.5rem;
  padding: 0.65rem 0.75rem;
  background: #fff;
  color: #2e3a46;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selector-item.selected {
  border-color: $color-cifra;
  background: rgba(254, 29, 18, 0.08);
}

.selector-item:hover {
  background: #fcedea;
}

.selector-item-texto {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.selector-item-profesor {
  font-weight: 400;
  color: #6c757d;
}
</style>
